import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { CompanyModel } from 'Pages/company'

export type CompanyState = {
	company: ResponseCatalog<CompanyModel>
	requestParams: RequestParams
	formState: {
		open: boolean
		item?: CompanyModel
	}
}

export const companyInitialState: CompanyState = {
	company: new ResponseCatalog<CompanyModel>(),
	requestParams: new RequestParams(),
	formState: {
		open: false,
		item: undefined,
	},
}

export namespace CompanyNS {
	export type GetCompanyList = PayloadAction<{
		params?: RequestParams
		clear?: boolean
	}>
	export type SetCompanyList = PayloadAction<ResponseCatalog<CompanyModel>>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type OpenForm = PayloadAction<{ item?: CompanyModel }>
	export type CloseForm = PayloadAction
}

export const companySlice = createSlice({
	name: 'company',
	initialState: companyInitialState,
	reducers: {
		getAll: (state, action: CompanyNS.GetCompanyList) => {},
		setAll: (state, action: CompanyNS.SetCompanyList) => {
			state.company = action.payload
		},
		setRequestParams: (state, action: CompanyNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.company = new ResponseCatalog<CompanyModel>()
			state.requestParams = new RequestParams()
		},
		openForm: (state, action: CompanyNS.OpenForm) => {
			state.formState = {
				open: true,
				item: action.payload.item,
			}
		},
		closeForm: (state, action: CompanyNS.CloseForm) => {
			state.formState = companyInitialState.formState
		},
	},
})
